import { Component, OnInit } from "@angular/core";
import {
  faSave,
  faTrash,
  faPrint,
  faPlus,
} from "@fortawesome/free-solid-svg-icons";
import { FormField } from "src/app/interfaces/form-field.model";
import { environment } from "src/environments/environment";
import { BuyersOrderReportDynamicService } from "src/app/services/sales-reports/buyers-order-report-dynamic.service";
import { preset } from "src/app/models/sales-reports/buyers-order-report-dynamic";

@Component({
  selector: "app-buyers-order-report-dynamic",
  templateUrl: "./buyers-order-report-dynamic.component.html",
  styleUrls: ["./buyers-order-report-dynamic.component.css"],
})
export class BuyersOrderReportDynamicComponent implements OnInit {
  faSave = faSave;
  faTrash = faTrash;
  faPrint = faPrint;
  faPlus = faPlus;

  preset: string = "";
  presetList: preset[] = [];

  showNewPreset: boolean = false;

  setForm: FormField[] = [
    {
      type: "select",
      id: "PresetIsGlobal",
      label: "Global Or Local Set",
      required: true,
      options: [
        { display: "Global", value: "Global" },
        { display: "Local", value: "Local" },
      ],
    },
  ];

  reportForm: FormField[] = [
    {
      type: "selectMultiple",
      id: "ReportFields",
      label: "Report Fields",
      value: [],
      options: [],
    },
  ];

  conditionFields: FormField[] = [
    {
      type: "select",
      id: "selectCondField",
      label: "",
      options: [],
    },
    {
      type: "select",
      id: "selectCondOp",
      label: "",
      show: false,
      options: [],
    },
    {
      type: "text",
      id: "$parent.selectedCondVal",
      label: "",
      show: false,
    },
    {
      type: "date",
      id: "selectedCondValFrom",
      label: "From Date (dd/mm/yyyy)",
      show: false,
    },
    {
      type: "date",
      id: "selectedCondValTo",
      label: "To Date (dd/mm/yyyy)",
      show: false,
    },
  ];

  sortFields: FormField[] = [
    {
      type: "select",
      id: "selectedSortField",
      label: "",
      options: [],
    },
    {
      type: "select",
      id: "selectedSortOp",
      label: "",
      value: "Ascending",
      options: [
        { display: "Ascending", value: "Ascending" },
        { display: "Descending", value: "Descending" },
      ],
    },
  ];

  conditionFormFields: FormField[] = [];

  selectCondOpOptionsStr = [
    {
      display: "Search",
      value: "object:2216",
    },
    {
      display: "Exact value",
      value: "object:2217",
    },
    {
      display: "Diferent than",
      value: "object:2218",
    },
  ];

  selectCondOpOptionsNo = [
    {
      display: "Greater Or Equal Than",
      value: "object:1074",
    },
    {
      display: "Greater Than",
      value: "object:1075",
    },
    {
      display: "Lower Than",
      value: "object:1076",
    },
    {
      display: "Lower Or Equal Than",
      value: "object:1077",
    },
    {
      display: "Equal To",
      value: "object:1078",
    },
    {
      display: "Diferent Than",
      value: "object:1079",
    },
  ];

  reportOptions = [
    { display: "BOOKING NO", value: "cb.REFNO" },
    { display: "BOOKING DATE", value: "cb.REFDATE" },
    { display: "CONTRACT NO", value: "cb.CONTRACTNO" },
    { display: "CONTRACT DATE", value: "sc.ContractDate" },
    { display: "REGISTER NO", value: "cb.REGISTERNO" },
    { display: "REGISTER DATE", value: "cb.REGISTRATIONDATE" },
    { display: "NRIC", value: "cb.NRIC" },
    { display: "Model Master Id", value: "cb.ModelMasterId" },
    { display: "Interior Color", value: "cb.IntColour" },
    { display: "Engine No", value: "cb.ENGINENUMBER" },
    { display: "Chasis No", value: "cb.CHASISNUMBER" },
    { display: "Sale Type", value: "cb.SALESTYPE" },
    { display: "Insurance", value: "cb.INSURANCE" },
    { display: "Ocupation", value: "cb.OCCUPATION" },
    { display: "Car Type", value: "cb.CARTYPE" },
    { display: "Coe Category", value: "cb.COECAT" },
    { display: "Loan Date", value: "cb.LOANDATE" },
    { display: "Expected Date", value: "cb.EXPECTEDDATE" },
    { display: "Inv. Price", value: "cb.INVOICEPRICE" },
    { display: "Inv. Discount", value: "cb.DISCOUNT" },
    { display: "Road Tax Period", value: "cb.ROADTAXPERIOD" },
    { display: "Road Tax Amount", value: "cb.ROADTAXAMT" },
    { display: "Loyalty Discount", value: "cb.RoyaltyDiscount" },
    { display: "CUSTOMER NAME", value: "c.Name" },
    { display: "VEHICLE MODEL", value: "cb.MODEL" },
    { display: "CASENUMBER", value: "cb.CASENUMBER" },
    { display: "COLOUR", value: "cb.COLOUR" },
    { display: "COE TYPE", value: "cb.COETYPE" },
    { display: "COE VALUE", value: "cb.COEVALUE" },
    { display: "COE OFFSET", value: "cb.COEOFFSET" },
    { display: "FIN COMP", value: "cb.FINCOMP" },
    { display: "LOAN AMOUNT", value: "cb.LOANAMOUNT" },
    { display: "LOANPERIOD", value: "cb.LOANPERIOD" },
    { display: "LOANRATE", value: "cb.LOANRATE" },
    { display: "LOAN REMARK", value: "cb.LOANREMARK" },
    { display: "FIN STATUS", value: "cb.FINSTATUS" },
    { display: "DEPOSIT AMOUNT", value: "cb.DEPOSIT" },
    { display: "FINAL PRICE", value: "cb.FINALPRICE" },
    { display: "SALESMAN CODE", value: "um.LoginID" },
    { display: "TEAM", value: "cb.TEAM" },
    { display: "ITEM 1", value: "sc.DelCerDesc1" },
    { display: "ITEM 2", value: "sc.DelCerDesc2" },
    { display: "ITEM 3", value: "sc.DelCerDesc3" },
    { display: "ITEM 4", value: "sc.DelCerDesc4" },
    { display: "ITEM 5", value: "sc.DelCerDesc5" },
    { display: "ITEM 6", value: "sc.DelCerDesc6" },
    { display: "ITEM 7", value: "sc.DelCerDesc7" },
    { display: "ITEM 8", value: "sc.DelCerDesc8" },
    { display: "ITEM 9", value: "sc.DelCerDesc9" },
    { display: "ITEM 10", value: "sc.DelCerDesc10" },
    { display: "ITEM 11", value: "sc.DelCerDesc11" },
    { display: "ITEM 12", value: "sc.DelCerDesc12" },
    { display: "PROMOTION", value: "fi.FREEITEM" },
    { display: "PROMOTION COST", value: "fi.COST" },
  ];

  dateFields = [
    "cb.REFDATE",
    "sc.ContractDate",
    "cb.REGISTRATIONDATE",
    "cb.LOANDATE",
    "cb.EXPECTEDDATE",
  ];

  stringFields = [
    "cb.REFNO",
    "cb.CONTRACTNO",
    "cb.REGISTERNO",
    "cb.NRIC",
    "cb.ModelMasterId",
    "cb.IntColour",
    "cb.ENGINENUMBER",
    "cb.CHASISNUMBER",
    "cb.SALESTYPE",
    "cb.INSURANCE",
    "cb.OCCUPATION",
    "cb.CARTYPE",
    "cb.COECAT",
    "c.Name",
    "cb.MODEL",
    "cb.CASENUMBER",
    "cb.COLOUR",
    "cb.COETYPE",
    "cb.FINCOMP",
    "cb.LOANREMARK",
    "cb.FINSTATUS",
    "um.LoginID",
    "cb.TEAM",
    "sc.DelCerDesc1",
    "sc.DelCerDesc2",
    "sc.DelCerDesc3",
    "sc.DelCerDesc4",
    "sc.DelCerDesc5",
    "sc.DelCerDesc6",
    "sc.DelCerDesc7",
    "sc.DelCerDesc8",
    "sc.DelCerDesc9",
    "sc.DelCerDesc10",
    "sc.DelCerDesc11",
    "sc.DelCerDesc12",
    "fi.FREEITEM",
  ];

  numericFields = [
    "cb.INVOICEPRICE",
    "cb.DISCOUNT",
    "cb.ROADTAXPERIOD",
    "cb.ROADTAXAMT",
    "cb.RoyaltyDiscount",
    "cb.COEVALUE",
    "cb.COEOFFSET",
    "cb.LOANAMOUNT",
    "cb.LOANPERIOD",
    "cb.LOANRATE",
    "cb.DEPOSIT",
    "cb.FINALPRICE",
    "fi.COST",
  ];

  conditionTableHeaders = [
    { title: "CONDITION", type: "data", id: "label" },
    { title: "OPERATOR", type: "data", id: "disp" },
    { title: "VALUE", type: "data", id: "val" },
    {
      title: "ACTION",
      type: "trash",
      id: "action",
      Hclasses: "text-center",
    },
    { title: "", type: "hidden", id: "$$hashKey" },
    { title: "", type: "hidden", id: "field" },
    { title: "", type: "hidden", id: "isDate" },
    { title: "", type: "hidden", id: "op" },
    { title: "", type: "hidden", id: "txt" },
  ];

  sortingTableHeaders = [
    { title: "FIELD NAME", type: "data", id: "label" },
    { title: "SORT BY", type: "data", id: "op" },
    {
      title: "ACTION",
      type: "trash",
      id: "action",
      Hclasses: "text-center",
    },
    { title: "", type: "hidden", id: "field" },
    { title: "", type: "hidden", id: "$$hashKey" },
  ];

  constructor(
    private BuyersOrderReportDynamicService: BuyersOrderReportDynamicService,
  ) {}

  ngOnInit(): void {
    this.BuyersOrderReportDynamicService.GetBuyersOrdersReportPreset().subscribe(
      {
        next: (response) => {
          this.presetList = response.body;
          this.preset = this.presetList[0].Id;
          this.getField("ReportFields", this.reportForm).options =
            this.reportOptions;
          this.handlePreset(this.presetList[0].StrConfig);
        },
        error: (error) => {
          console.log(error);
        },
      },
    );
  }

  updateFields(event: any): void {
    switch (event.name) {
      case "conditionFields": {
        const selectCondField = this.getField(
          "selectCondField",
          this.conditionFields,
        ).value;

        const valFromField = this.getField(
          "selectedCondValFrom",
          this.conditionFields,
        );
        const valToField = this.getField(
          "selectedCondValTo",
          this.conditionFields,
        );
        const opField = this.getField(
          "selectCondOp",
          this.conditionFields,
        );
        const valField = this.getField(
          "$parent.selectedCondVal",
          this.conditionFields,
        );

        [valFromField, valToField, opField, valField].forEach(
          (f) => (f.show = false),
        );

        if (this.dateFields.includes(selectCondField)) {
          valFromField.show = true;
          valToField.show = true;
          break;
        }

        const isString = this.stringFields.includes(selectCondField);
        const isNumeric =
          this.numericFields.includes(selectCondField);

        if (isString || isNumeric) {
          opField.show = true;
          opField.options = isString
            ? this.selectCondOpOptionsStr
            : this.selectCondOpOptionsNo;
          valField.type = isString ? "text" : "number";
          valField.show = true;
        }
        break;
      }
    }
  }

  handlePreset(strConfig: string): void {
    const parsedConfig = JSON.parse(strConfig);

    const availableOptions = parsedConfig.PresetFields.map(
      (item: any) => ({
        display: item.desc,
        value: item.val,
      }),
    );

    console.log(parsedConfig);

    this.getField("ReportFields", this.reportForm).value =
      availableOptions;
    this.getField("selectedSortField", this.sortFields).options =
      availableOptions;
    this.getField("selectCondField", this.conditionFields).options =
      availableOptions;
    this.getField("PresetIsGlobal", this.setForm).value =
      parsedConfig.PresetIsGlobal;

    this.conditionTableEntries = parsedConfig.PresetConditions;
    this.sortingTableEntries = parsedConfig.PresetSorts;

    this.updateFields(null);
  }

  addPreset(): void {
    this.showNewPreset = true;
  }

  conditionTableEntries: any[] = [];
  sortingTableEntries: any[] = [];

  /* openConditionForm(): void {
    const selectedConditionValue = this.getField(
      "Condition",
      this.conditionFields,
    )?.value;
    if (!selectedConditionValue) return;

    const reportFields = this.reportForm.find(
      (f) => f.id === "ReportFields",
    );
    const selectedConditionDisplay = reportFields?.options
      ? reportFields.options.find(
          (opt) => opt.value === selectedConditionValue,
        )?.display || selectedConditionValue
      : selectedConditionValue;

    this.conditionFormFields = [];

    if (this.dateFields.includes(selectedConditionValue)) {
      this.conditionFormFields = [
        {
          type: "text",
          id: "fieldName",
          label: "Field",
          value: selectedConditionDisplay,
          lock: true,
        },
        {
          type: "date",
          id: "fromDate",
          label: "From Date (dd/mm/yyyy)",
          value: "",
        },
        {
          type: "date",
          id: "toDate",
          label: "To Date (dd/mm/yyyy)",
          value: "",
        },
      ];
    } else if (this.stringFields.includes(selectedConditionValue)) {
      this.conditionFormFields = [
        {
          type: "text",
          id: "fieldName",
          label: "Field",
          value: selectedConditionDisplay,
          lock: true,
        },
        {
          type: "select",
          id: "conditionType",
          label: "Select condition",
          value: "",
          options: [
            { display: "Search", value: "search" },
            { display: "Exact value", value: "exact" },
            { display: "Different than", value: "different" },
          ],
        },
        {
          type: "text",
          id: "conditionValue",
          label: "Value",
          value: "",
        },
      ];
    } else if (this.numericFields.includes(selectedConditionValue)) {
      this.conditionFormFields = [
        {
          type: "text",
          id: "fieldName",
          label: "Field",
          value: selectedConditionDisplay,
          lock: true,
        },
        {
          type: "select",
          id: "conditionType",
          label: "Select condition",
          value: "",
          options: [
            { display: "Greater Or Equal Than", value: ">=" },
            { display: "Greater Than", value: ">" },
            { display: "Lower Than", value: "<" },
            { display: "Lower Or Equal Than", value: "<=" },
            { display: "Equal To", value: "=" },
            { display: "Different Than", value: "!=" },
          ],
        },
        {
          type: "text",
          id: "conditionValue",
          label: "Value",
          value: "",
        },
      ];
    }
  } */

  addCondition(): void {
    const selectedField = this.getField(
      "selectCondField",
      this.conditionFields,
    );
    const dateFrom = this.getField(
      "selectedCondValFrom",
      this.conditionFields,
    ).value;
    const dateTo = this.getField(
      "selectedCondValTo",
      this.conditionFields,
    ).value;

    console.log(selectedField);
    if (this.dateFields.includes(selectedField.value)) {
      this.conditionTableEntries.push(
        {
          label: this.reportOptions.find(
            (item) => item.value == selectedField.value,
          )?.display,
          field: selectedField.value,
          disp: "From",
          val: this.convertDateFormat(dateFrom),
          $$hashKey: "",
          isDate: true,
          op: "",
          txt: "",
        },
        {
          label: this.reportOptions.find(
            (item) => item.value == selectedField.value,
          )?.display,
          field: selectedField.value,
          disp: "To",
          val: this.convertDateFormat(dateTo),
          $$hashKey: "",
          isDate: true,
          op: "",
          txt: "",
        },
      );
      console.log(this.conditionTableEntries);
    }

    /* const conditionValue =
      this.getField("selectedCondValFrom", this.conditionFormFields)
        ?.value || "";
    const conditionType =
      this.getField("conditionType", this.conditionFormFields)
        ?.value || "";

    const selectedConditionValue =
      this.getField("condition", this.conditionFields)?.value || "";
    const isDateField = this.dateFields.includes(
      selectedConditionValue,
    );

    if (isDateField) {
      let fromDate =
        this.getField("fromDate", this.conditionFormFields)?.value ||
        "";
      let toDate =
        this.getField("toDate", this.conditionFormFields)?.value ||
        "";

      fromDate = this.convertDateFormat(fromDate);
      toDate = this.convertDateFormat(toDate);

      this.conditionTableEntries.push(
        {
          condition: fieldName,
          operator: "From",
          value: fromDate,
          trash: "",
        },
        {
          condition: fieldName,
          operator: "To",
          value: toDate,
          trash: "",
        },
      );
    } else {
      this.conditionTableEntries.push({
        condition: fieldName,
        operator: conditionType,
        value: conditionValue,
        trash: "",
      });
    }

    this.conditionFormFields = []; */
  }

  convertDateFormat(dateString: string): string {
    if (!dateString) return "";

    const parts = dateString.split("-");
    if (parts.length === 3) {
      return `${parts[2]}/${parts[1]}/${parts[0]}`;
    }

    return dateString;
  }

  formatDate(dateString: string): string {
    if (!dateString) return "";

    const date = new Date(dateString);
    if (isNaN(date.getTime())) return dateString;

    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();

    return `${day}/${month}/${year}`;
  }

  formatDateQuery(dateString: string): string {
    if (!dateString) return "";

    const parts = dateString.split("/");
    if (parts.length === 3) {
      return `${parts[1]}/${parts[0]}/${parts[2]}`;
    }

    return dateString;
  }

  removeCondition(entry: any): void {
    const index = this.conditionTableEntries.indexOf(entry);
    if (index >= 0) {
      this.conditionTableEntries.splice(index, 1);
    }
  }

  addSorting(): void {
    const selectedSortBy = this.getField(
      "SortBy",
      this.sortFields,
    )?.value;
    const selectedSortType = this.getField(
      "SortType",
      this.sortFields,
    )?.value;

    if (!selectedSortBy || !selectedSortType) return;

    const reportFields = this.reportForm.find(
      (f) => f.id === "ReportFields",
    );
    const options = reportFields?.options || [];

    const sortFieldDisplay =
      options.find((opt) => opt.value === selectedSortBy)?.display ||
      selectedSortBy;

    const alreadyExists = this.sortingTableEntries.some(
      (entry) => entry.fieldName === sortFieldDisplay,
    );
    if (alreadyExists) return;

    this.sortingTableEntries.push({
      fieldName: sortFieldDisplay,
      sortType: selectedSortType === "Ascending" ? "ASC" : "DESC",
      trash: "",
    });

    console.log("Sorting added:", this.sortingTableEntries);
  }

  removeSorting(entry: any): void {
    const index = this.sortingTableEntries.indexOf(entry);
    if (index >= 0) {
      this.sortingTableEntries.splice(index, 1);
    }
  }

  exportReport(): void {
    const reportField = this.reportForm.find(
      (f) => f.id === "ReportFields",
    );

    if (
      !reportField ||
      !Array.isArray(reportField.value) ||
      reportField.value.length === 0
    ) {
      alert("Kindly select report fields");
      return;
    }

    const selectedFields = reportField.value as (
      { display: string; value: string } | string
    )[];
    const fieldArr = selectedFields.map((f) =>
      typeof f === "string" ? f : f.value,
    );

    let conditions = "";
    let conditions2 = "";
    let hasDateCondition = false;

    this.conditionTableEntries.forEach((entry) => {
      const fieldValue = this.getFieldValue(entry.condition);

      if (this.dateFields.includes(fieldValue))
        hasDateCondition = true;

      const operator = entry.operator === "From" ? ">=" : "<=";

      const formattedValue = this.dateFields.includes(fieldValue)
        ? this.formatDateQuery(entry.value)
        : entry.value;

      conditions += ` and ${fieldValue} ${operator} '${formattedValue}'`;
      conditions2 += `${fieldValue.split(".")[1]} `;
    });

    if (
      this.conditionTableEntries.length === 0 ||
      !hasDateCondition
    ) {
      alert("Select at least one time condition");
      return;
    }

    let sorts = "";
    let sortField = "";
    let sortDirection = "";

    if (this.sortingTableEntries.length === 0) {
      alert("Select at least one sorting condition");
      return;
    } else {
      this.sortingTableEntries.forEach((entry, i) => {
        const fieldValue = this.getFieldValue(entry.fieldName);
        const srt = i === 0 ? " ORDER BY " : ", ";
        sorts += srt + fieldValue + " " + entry.sortType;
        sortField = fieldValue.split(".")[1];
        sortDirection = entry.sortType;
      });
    }

    let joins = `
    LEFT JOIN UserMaster um on cb.SALESMAN = um.UserId
    LEFT JOIN SalesContract sc on sc.ContractNo = cb.CONTRACTNO
    LEFT JOIN vwCustomer c on cb.NRIC = c.IcNo
  `;

    if (
      fieldArr.includes("fi.FREEITEM") ||
      fieldArr.includes("fi.COST")
    ) {
      joins +=
        " LEFT JOIN FreeItems fi on sc.ContractNo = fi.CONTRACTNO";
    }

    let sqlQuery = `SELECT ${fieldArr.filter((f) => f).join(", ")} FROM TblContractBooking cb ${joins} WHERE (cb.BKFLAG IS NULL OR cb.BKFLAG != 'C') ${conditions}`;

    sqlQuery = sqlQuery
      .replace(/\s*,\s*/g, ", ")
      .replace(/^,|,$/g, "");

    const queryParams = new URLSearchParams();
    queryParams.append("report_id", "BookingReportDynamic");
    queryParams.append("SQLTxt", sqlQuery);
    queryParams.append("sortingField", sortField);
    queryParams.append("sortingDirection", sortDirection);
    queryParams.append("conditions", conditions2.trim());
    queryParams.append("format", "e");

    let finalUrl =
      `${environment.KAPS_V1_DIRECT_URL}Reports/ReportLoader.aspx?` +
      queryParams.toString();

    finalUrl = finalUrl
      .replace(/\+/g, "%20")
      .replace(/%3D/g, "=")
      .replace(/%21%3D/g, "!=")
      .replace(/%21/g, "!")
      //.replace(/%3C/g, "!")
      .replace(/%28/g, "(")
      .replace(/%29/g, ")")
      .replace(/%2F/g, "/")
      .replace(/%2C/g, ",")
      .replace(/%0A/g, "")
      .replace(/%0D/g, "")
      .replace(/%09/g, "")
      .replace(/(%20){2,}/g, "%20")
      .replace(/%20(?=[,])/g, "")
      .replace(/(?<=,)%20/g, "");

    window.open(finalUrl);
  }

  getFieldValue(displayName: string): string {
    return (
      this.reportForm
        .find((f) => f.id === "ReportFields")
        ?.options?.find((opt) => opt.display === displayName)
        ?.value || displayName
    );
  }

  getField(id: string, group: FormField[]): FormField {
    return (
      group.find((f) => f.id === id) ?? {
        id: "",
        label: "",
        type: "text",
      }
    );
  }
}
